import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",
    mobile: {
      desktop: {
        padding: 100,
      },
      smartphone: {
        padding: 20,
      },
    },
  },
  HEADLINE: {
    textAlign: "center",
    fontFamily: theme.fontFamily,
    paddingBottom: 10,
    mobile: {
      desktop: {
        fontSize: "32pt",
        fontWeight: "bold" as "bold",
      },
      smartphone: {
        fontSize: "26pt",
        fontWeight: "bold" as "bold",
      },
    },
    color: theme.backgroundColor,
  },
  SUBHEADLINE: {
    fontSize: "18pt",
    lineHeight: "18pt",
    fontFamily: theme.fontFamily,
    fontWeight: "bold" as "bold",
    textAlign: "center",
    color: "black",
  },
  TEXT: {
    textAlign: "center",
    fontFamily: theme.fontFamily,
    fontSize: "13pt",
    lineHeight: "18pt",
    mobile: {
      desktop: {
        padding: 30,
      },
      smartphone: {
        padding: 10,
      },
    },
  },
  BUTTON: {
    style: {
      display: "inline-block",
      padding: "10px 75px",
      width: "100%",
      marginTop: 10,
      border: "none",
      backgroundColor: theme.backgroundColor,
      borderRadius: 3,
      cursor: "pointer",
    },
    caption1: {
      color: theme.foregroundColor,
      fontWeight: "bold" as "bold",
      fontSize: "10pt",
    },
  },
  FORM_FIELD: {
    style: { width: "100%" },
    inputStyle: {
      width: "100%",
      padding: 15,
      backgroundColor: "transparent",
      border: "1px solid #DDD",
      borderRadius: 5,
      marginTop: 10,
    },
    labelStyle: {
      fontFamily: "Roboto",
      fontSize: "10pt",
      textAlign: "left",
      padding: 5,
    },
  },
  LISTITEM: {
    style: {
      color: theme.foregroundColor,
      fontFamily: theme.fontFamily,
      // padding: "10px 0"
    },
    iconStyle: {
      borderRadius: "100%",
      padding: 10,
      color: theme.foregroundColor,
    },
    contentStyle: {
      padding: 10,
    },
  },
};
